import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_REFUELING } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Refuelings from '../../components/Refuelings';

export const Route = createFileRoute('/_authenticated/refuelings/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_REFUELING, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'menu.refuelingsOverview',
      },
    };
  },
  // Modal opened by the Refuelings list based on the URL.
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  return <Refuelings mode="add" />;
}
